// Material UI
import { makeStyles } from '@material-ui/core'
// Constant
import Colors from '../../constants/Colors'

export default makeStyles(theme => ({
  root: {},
  flexContainer: {
    display: 'flex',
    flexWrap: 'nowrap',
    borderBottom: `1px solid ${Colors.DISABLED_COLOR}`,
    padding: '24px',
    flexDirection: 'row',
  },
  flexContainerTwo: {
    display: 'flex',
    flexWrap: 'wrap',
    flexDirection: 'column',
  },
  fontRtinfo: {
    paddingLeft: '21px',
    fontSize: '13px',
    fontFamily: 'Poppins',
    color: Colors.SECONDARY_FONT_COLOR,
  },
  marginPhone: {
    marginLeft: '18px',
  },
  rtName: {
    fontSize: '15px',
    fontFamily: 'Poppins',
    color: Colors.PRIMARY_FONT_COLOR,
    letterSpacing: '0',
    paddingLeft: '20px',
  },
  avatarBox: {
    position: 'absolute',
  },
}))
